import { instance } from '@/services/avik-api-gateway'
import { AxiosResponse } from 'axios'
import { DefectCloseReport } from '@/types/defect-close-report'

export function postVehicleDefectFromDb(
  defect_codes: number[]
): Promise<AxiosResponse<DefectCloseReport[]>> {
  return instance.post(`/vehicle-defect-from-db`, defect_codes)
}
